import { render } from "./ProjectTitleCard.vue?vue&type=template&id=81c6fb12"
import script from "./ProjectTitleCard.vue?vue&type=script&lang=js"
export * from "./ProjectTitleCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__